import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IimPaginationModule, IimSpinnerModule } from '@iim-angular/components';
import {
    ArticleCardComponent,
    ArticleCardGridComponent,
    ArticleRowComponent,
    ArticleRowListComponent,
} from '@lib/shared/article-card/ui';
import { UnitModule } from '@lib/unit';
import { TranslateModule } from '@ngx-translate/core';
import { OciSearchResultsComponent } from './oci-search-results.component';
import { DisplayCurrencyModule } from '@lib/util';

@NgModule({
    declarations: [OciSearchResultsComponent],
    imports: [
        CommonModule,
        IimSpinnerModule,
        TranslateModule,
        IimPaginationModule,
        ArticleCardComponent,
        ArticleCardGridComponent,
        ArticleRowComponent,
        ArticleRowListComponent,
        UnitModule,
        DisplayCurrencyModule,
    ],
    exports: [OciSearchResultsComponent],
})
export class OciSearchResultsModule {}
